import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { NodeFAQ } from '../../../../types/uncinc_profile/nodes';
import type { ThemeGroup } from '..';

function groupNodeFaqPerTheme(entities: ImmutableEntity<NodeFAQ[]>): ThemeGroup[] {
  const group: ThemeGroup[] = [];

  entities.toJS().forEach((faq) => {
    const themes = faq.field_themes;

    // An Faq node can be linked to more than one theme, so loop over all of them.
    themes.forEach((theme) => {
      // If a theme already exists, add the faq to the theme.
      const existingTheme = group.find(({ themeId }) => themeId === theme.target_id);
      if (existingTheme) {
        existingTheme.faqs.push(faq);
        return;
      }

      // We separate themes in "themes" and "subjects", where "themes" are parent themes
      // and "subjects" are child themes. In this case we're only interested in the parents.
      if (theme.entity.parent[0]?.target_id !== null) {
        return;
      }

      // If a theme does not exist yet, add one to the group.
      group.push({
        themeId: theme.target_id,
        themeName: theme.entity.name[0].value,
        themeUrl: theme.url ?? '',
        faqs: [faq],
      });
    });
  });

  return group;
}

export default groupNodeFaqPerTheme;
